/// <reference path="../global.d.ts" />
/// <reference path="./searchIpGeo.library.d.ts" />

/*!
 * @preserve
 * Detect.js
 * BrowserInfoCollector Frontend JS for dein-ip-check.de (Modul: detectGeo->detectGeo_Whois)
 *
 * @version 3.1.6
 * @author Jens Dutzi <jens.dutzi@tf-network.de>
 * @website http://www.dein-ip-check.de
 * @license Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

// MAP-Variable
import {searchIpWhois} from "./searchIpWhois.library";
import {Circle, Icon, LatLngExpression, Marker} from "leaflet";

export let map: any;

/**
 * Interfaces für die PINs und POST-Request
 */
export interface postDataType {
    REQUEST_TOKEN: string;
    ip: string;
}

interface pinData {
    markerLayer: Marker,
    circleLayer: Circle
}

interface pinStyle {
    zoomLevel: number,
    radius: number,
    strokeColor: string,
    fillColor: string,
    icon: Icon
}

interface GeoIpInformation {
    longitude: number,
    latitude: number,
    accuracyRadius: number
}

/**
 * PIN A definieren
 */
let pinA:pinData = {markerLayer: undefined, circleLayer: undefined};
let pinAstyle:pinStyle = {
    zoomLevel: 9, radius: 30000,
    strokeColor: "rgb(216, 98, 99)", fillColor: "rgba(231, 159, 160, 0.4)",
    icon: L.icon({ iconUrl: "/bundles/deinipcheckbrowserinfo/img/MarkerA.png", iconSize: [46, 46]})
};

/**
 * Alle Methoden zum generieren der OpenStreetmap Karte
 */
export class searchIpGeo {
    /**
     * Formular-Ziel ermitteln
     */
    public static getPostURL(): string {
        let postURL = document.createElement('a');
        postURL.href = $('#ipSearchForm').attr('action');

        return postURL.pathname;
    }

    /**
     * Rufe das Ergebnis der IP-Suche per AJAX ab
     * 
     * @param clientip
     */
    public static startAjaxRequest(clientip: string) {
        // AJAX Route aus entsprechendem Data-Tag auslesen
        let actionRoute = document.createElement('a');
        actionRoute.href = $('#ipSearchForm').attr('data-ajax');

        // Post-Data zusammensetzen
        let postData: postDataType = {
            REQUEST_TOKEN: $('input[name=REQUEST_TOKEN]').val().toString(),
            ip: clientip,
        };
        
        // Button während Request deaktivieren
        $('#ipSearchForm #ctrl_submit').html(
            DETECTPHRASE['submit'] + '<i style=\'margin-left: 10px;\' class=\'fas fa-circle-o-notch fa-spin\'></i>'
        ).prop('disabled', true);
        
        // Ajax request ausführen
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: actionRoute.pathname,
            data: jQuery.param(postData),
        })
            .done(response => {
                $('#ipSearchResult').html(response.result)

                // Karte und Whois/Clipboard initialisieren
                if($('#karte').length <= 1) {
                    searchIpGeo.initMap('map');
                }
                searchIpGeo.setPosition(response.longitude, response.latitude, response.accuracyRadius);

                // Whois-Click Event bei Bedarf initialsieren
                searchIpWhois.initWhoisIP("#ipwhois");

                // Aktualisiere History
                history.pushState(
                    {
                        "ip": postData.ip, 
                        'longitude': response.longitude,
                        'latitude': response.latitude,
                        'accuracyRadius': response.accuracyRadius,
                        "html":response.result
                    },
                    null,`${searchIpGeo.getPostURL()}?${jQuery.param({"ip": postData.ip})}`
                );
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                // Fehler-Handling
                let result = `<div class='alert alert-danger' role='alert'><div id='errorText'>${DETECTPHRASE['Fehler bei der AJAX Abfrage']} (${textStatus})</div></div>`;
                $('#ipSearchResult').html(result);
                console.error(errorThrown);
                
                // History aktualisieren
                history.pushState(
                    {"ip": postData.ip, 'longitude': null, 'latitude': null, 'accuracyRadius': null, "html": result},
                    null, searchIpGeo.getPostURL()
                );
            })
            .then(function() {
                // Button wieder freigeben
                $('#ipSearchForm #ctrl_submit').html(DETECTPHRASE['submit']).prop('disabled', false);
            });
    }
    
    /**
     * OpenStreetmap Karte initialisieren
     *
     * @param mapElement    DOM-ID
     */
    public static initMap(mapElement: string) {
        // Karte initialisieren
        map = L.map('map').fitWorld();

        L.tileLayer('//maps.dein-ip-check.de/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.de">OpenStreetMap</a> - Mitwirkende'
        }).addTo(map);
        map.attributionControl.setPrefix(false);
        map.scrollWheelZoom.disable();
        L.control.scale().addTo(map);

        /**
         * Reagiere auf Click-Handler
         */
        $('#pinA').on("click", function(){
            map.fitBounds( pinA.circleLayer.getBounds() );
        });
    }

    public static setPosition(longitude:number, latitude:number, accuracy:number) {
        let positionInfo: GeoIpInformation = {
            longitude: longitude,
            latitude: latitude,
            accuracyRadius: accuracy,
        };
        
        this.updateOpenStreetMaps(
            'pinA',
            latitude, longitude, positionInfo.accuracyRadius * 1000,
            pinAstyle.strokeColor, pinAstyle.fillColor, pinAstyle.icon, 
            true
        )
    }
    
    /**
     * Hilfsfunktion: Setze PIN und Kreis auf Google Maps
     *
     * @param markerName
     * @param latitude
     * @param longitude
     * @param radius
     * @param strokeColor
     * @param fillColor
     * @param icon
     * @param panToMarker
     * @returns object
     */
    private static updateOpenStreetMaps(
        markerName:string,
        latitude:number, longitude:number, radius:number,
        strokeColor:string, fillColor:string, icon:Icon,
        panToMarker:boolean
    ) {
        // Position von String in Float-Wert umwandeln
        let latLon:LatLngExpression = {
            lat: latitude,
            lng: longitude,
        }

        // Marker und Circle hinzufügen
        let marker_MarkerLayer = L.marker(latLon, {icon: icon}).addTo(map);

        let marker_CircleLayer = L.circle(latLon, radius, {
            color: strokeColor,
            fillColor: fillColor,
            fillOpacity: 0.5
        }).addTo(map);

        if(panToMarker) {
            map.fitBounds( marker_CircleLayer.getBounds() );
        }
                        
        // Button freigeben
        $("#" + markerName).prop("disabled", false).show();
        
        pinA.circleLayer = marker_CircleLayer;
        pinA.markerLayer = marker_MarkerLayer;
    }
}
